import { render, staticRenderFns } from "./EurFaq.vue?vue&type=template&id=33ba3795"
import script from "./EurFaq.vue?vue&type=script&lang=js"
export * from "./EurFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports